import { render, staticRenderFns } from "./PostBottom.vue?vue&type=template&id=1d4dc21f&scoped=true&"
import script from "./PostBottom.vue?vue&type=script&lang=js&"
export * from "./PostBottom.vue?vue&type=script&lang=js&"
import style0 from "./PostBottom.vue?vue&type=style&index=0&id=1d4dc21f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4dc21f",
  null
  
)

export default component.exports